export const SET_AUTH_DATA = 'SET_AUTH_DATA'
export const UNSET_AUTH_DATA = 'UNSET_AUTH_DATA'

